import { Component, OnInit } from '@angular/core';
import { FilterPipe } from 'ngx-filter-pipe';
import { ApiService } from '../../services/api.service';
import { Global } from '../../global';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-alteracao-escala',
  templateUrl: './alteracao-escala.component.html',
  styleUrls: ['./alteracao-escala.component.css']
})
export class AlteracaoEscalaComponent implements OnInit {

  escolheData: boolean = false;
  loading: boolean = false;
  currentUser: any = {};
  justificativa_alteracao: any = {};
  filtroSelecionado: any = {};
  solicita: any = {};
  listaUnidades: any = [];
  listaSetores: any = [];
  listaMotivos: any = [];
  listaFuncionarios: any = [];
  listaEscalaAssumir: any = [];
  listaEscalaRepassar: any = [];
  setor: any = {};
  escalas: any = {};
  listaRequisicoes: any = [];
  filtro_historico: any = {};
  selectedItems: any = [];
  dropdownSettings = {
    singleSelection: false,
    text: "Selecione...",
    selectAllText: 'Selecionar Todos',
    unSelectAllText: 'Cancelar Todos',
    enableSearchFilter: false,
    classes: "myclass custom-class"
  };
  constructor(
    private apiService: ApiService,
    public global: Global,
    public dialog: MatDialog,
    private router: Router,
    private filter: FilterPipe
  ) {
    try {
      if (localStorage.getItem("currentUser") == null)
        this.router.navigate(["/login"]);
      this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    } catch (err) {
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit() {
    this.obterUnidades();
    this.justificativa_alteracao = {};
    this.filtro_historico.mes = (new Date()).getMonth() + 1;
    this.filtro_historico.ano = (new Date()).getFullYear();
    this.buscarHistorico();
    this.obterMotivos();

  }

  obterEscalasFuncionario() {
    this.obterEscalasRepassar(this.currentUser.uuid, this.justificativa_alteracao.setor);
  }

  submit() {
    this.loading = true;
    if (this.validoJustificativaAlteracao()) {
      this.justificativa_alteracao.escalas = [];
      // if ($(".dateEscala").val() != "" && $(".dataEscala").val() != "") {
      //   var listaData = [];
      //   listaData = $(".dateEscala").val().split(',');
      //   listaData.forEach(element => {
      //     var dado = this.listaEscalaRepassar.filter(x => x.data_formatada == element);
      //     if (dado.length > 0) {
      //       this.justificativa_alteracao.escalas.push({
      //         escala_uuid: dado[0].uuid,
      //         motivo_uuid: this.justificativa_alteracao.motivo_uuid
      //       });
      //     }
      //   });
      // }
      this.justificativa_alteracao.escalas.push({
        escala_uuid: this.justificativa_alteracao.escala,
        motivo_uuid: this.justificativa_alteracao.motivo_uuid
      })
      // this.selectedItems.forEach(element => {
      //   this.justificativa_alteracao.escalas.push({
      //     escala_uuid: element.uuid,
      //     motivo_uuid: this.justificativa_alteracao.motivo_uuid
      //   });
      // });  
      console.log(this.justificativa_alteracao)    
      this.apiService.Post("AlteracaoEscala", this.justificativa_alteracao.escalas).then(
        result => {
          this.listaFuncionarios = result;
          this.obterEscalasRepassar(this.currentUser.uuid, this.justificativa_alteracao.setor);
          this.ngOnInit();
          this.selectedItems = [];
          this.justificativa_alteracao = {};
          this.justificativa_alteracao.unidade = null;
          this.justificativa_alteracao.setor = null;
          this.justificativa_alteracao.escala_uuid = null;
          this.justificativa_alteracao.motivo_uuid = null;
          $('.dateEscala').datepicker("destroy");
          Swal.fire({
            type: 'success',
            title: 'Sucesso!',
            text: 'Justificativa de escala enviada com sucesso!'
          });
        },
        err => {
          if (err.status == 401) {
            this.router.navigate(["/login"]);
            this.loading = false;
            return;
          }
          Swal.fire({
            type: 'error',
            title: 'Oops...',
            text: err.error.mensagem
          });
        }
      );
    }
    this.loading = false;
  }

  obterUnidades() {
    this.loading = true;
    this.apiService.Get("Unidades").then(
      result => {
        this.listaUnidades = result;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }

  obterSetores(unidade_id) {
    if (unidade_id == 0) {
      this.listaSetores = null;
      return;
    }
    this.loading = true;
    this.apiService.Get("Unidades/" + unidade_id + "/Setores?ativo=true").then(
      result => {
        this.listaSetores = result;
        this.setor = null;
        this.loading = false;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
  }

  validoJustificativaAlteracao() {
    if (this.justificativa_alteracao.unidade == null || this.justificativa_alteracao.unidade == "" || this.justificativa_alteracao.unidade == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira a unidade!'
      });
      return false;
    }
    if (this.justificativa_alteracao.setor == null || this.justificativa_alteracao.setor == "" || this.justificativa_alteracao.setor == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira o setor!'
      });
      return false;
    }

    if (this.justificativa_alteracao.escala == "" || this.justificativa_alteracao.escala == null) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Selecione uma escala!'
      });
      return false;
    }

    // if (this.selectedItems.length == 0) {

    // }
    // if (this.justificativa_alteracao.escala_uuid == null || this.justificativa_alteracao.escala_uuid == "" || this.justificativa_alteracao.escala_uuid == 0) {
    //   Swal.fire({
    //     type: 'error',
    //     title: 'Oops...',
    //     text: 'Insira a escala!'
    //   });
    //   return false;
    // }
    if (this.justificativa_alteracao.motivo_uuid == null || this.justificativa_alteracao.motivo_uuid == "" || this.justificativa_alteracao.motivo_uuid == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira o motivo!'
      });
      return false;
    }
    return true;
  }

  validoSolicitar(funcionario) {
    if (funcionario.assumido == null || funcionario.assumido == "" || funcionario.assumido == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira uma escala para assumir!'
      });
      return false;
    }
    if (funcionario.repassar == null || funcionario.repassar == "" || funcionario.repassar == 0) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Insira uma escala para repassar!'
      });
      return false;
    }
    return true;
  }

  obterEscalasPossiveis(funcionario) {
    var funcionario_id = funcionario.uuid
    if (funcionario_id == 0 || funcionario_id == null) {
      this.listaEscalaAssumir = null;
      this.solicita = null;
      return;
    }
    this.loading = true;
    funcionario.assumir = !funcionario.assumir;
    funcionario.assumido = null;
    funcionario.repassar = null;
    this.escolheData = !this.escolheData;
    this.loading = false;
  }

  obterEscalasRepassar(funcionario_id, setor_uuid) {

    if (funcionario_id == 0 || funcionario_id == null) {
      this.listaEscalaAssumir = null;
      return;
    }
    this.loading = true;
    this.apiService.Get("Funcionarios/" + funcionario_id + "/Escalas?setor_uuid=" + setor_uuid).then(
      result => {
        let list: any = [];
        list = result;
        list.forEach(element => {
          element.itemName = this.dataFormat(element.data_escala) + " - " + element.turno_nome;
          element.id = element.uuid;
          element.data_formatada = this.dataFormat(element.data_escala);
          element.data = new Date(element.data_escala);

        });
        this.listaEscalaRepassar = list;
        this.loading = false;
        var dataInicial: any = new Date(list[0].data_escala);
        var dataInicialBlock: any = new Date(list[0].data_escala);

        var dataFinal: any = new Date(list[list.length - 1].data_escala);
        var disableDates = [];

        do {
          dataFinal = new Date(list[list.length - 1].data_escala);
          dataInicial = dataInicial.addDays(1);
          let listArray: any = [];
          let dataFormat_ = this.dataFormat(dataInicial)
          listArray = list.filter(x => x.data_formatada == dataFormat_);
          if (listArray.length == 0) {
            disableDates.push(dataFormat_);
          }
        } while (dataInicial < dataFinal);

        // $('.dateEscala').datepicker({
        //   format: "dd/mm/yyyy",
        //   maxViewMode: 3,
        //   clearBtn: false,
        //   language: "pt-BR",
        //   multidate: true,
        //   daysOfWeekHighlighted: "0,6",
        //   todayHighlight: true,
        //   orientation: 'bottom auto',
        //   datesDisabled: disableDates,
        //   startDate: dataInicialBlock,
        //   endDate: dataFinal,
        // });
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
  }

  dataFormat(data) {
    return this.global.dateFormater(data);
  }

  obterMotivos() {
    this.loading = true;
    this.apiService.Get("MotivosAlteracaoEscala").then(
      result => {
        this.listaMotivos = result;
        this.loading = false;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
  }

  buscarHistorico() {
    this.loading = true;
    this.apiService.Get("AlteracaoEscala?mes=" + this.filtro_historico.mes + "&ano=" + this.filtro_historico.ano).then(
      result => {
        this.listaRequisicoes = result;
        this.loading = false;
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
  }

  onItemSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }

  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  onDeSelectAll(items: any) {
    console.log(items);
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/alteracao-escala/alteracao-escala.component.ts